var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"embed",staticClass:"embed",style:(_vm.style)},[_c('resize-observer',{on:{"notify":_vm.setHeight}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }